import React, { Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'

import uuid from 'uuid4'

import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'

import CustomMenu from '../customMenu'
import MenuItem from '@material-ui/core/MenuItem'

import { ListItemText, CircularProgress, Tooltip } from '@material-ui/core'

import './index.scss'

import { api } from '../../../functions/api'
import CheckCircle from '@material-ui/icons/CheckCircle'
import Error from '@material-ui/icons/Error'
import RemoveCircle from '@material-ui/icons/RemoveCircle'
import ListItemIcon from '@material-ui/core/ListItemIcon'

@inject('internal')
@inject('translate')
@observer
export default class CustomIconButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            anchorEl: null,
            openDeleteDialog: false,
            loading: false
        }
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ anchorEl: null })
    }

    setReadNotification = async id => {
        let set_data = await api({
            method: 'patch',
            url: `user/notifications/${id}/read`,
            authorization: this.props.internal.user.access_token
        })

        if (set_data.success) {
            this.getUserData()
        }
    }

    getUserData = async () => {
        let load_data = await api({
            method: 'get',
            url: 'user',
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success === true) {
            localStorage.setItem('user', JSON.stringify(load_data.data))
            this.props.internal.loginUser(load_data.data, true)
        }
    }

    loginAsUser = async (clientId, memberId) => {
        let response = await api({
            method: 'get',
            url: `clients/${clientId}/members/${memberId}/login-as`,
            authorization: this.props.internal.user.access_token
        })

        if (true === response.success) {
            if (response.data.data.access_token) {
                // this.props.internal.setSnackbar(load_data.data.message, true)
                this.props.internal.loginUser(response.data.data, false)
                localStorage.setItem('access_token', JSON.stringify(response.data.data))
                await this.getUserData()
                window.location.reload()
                // this.props.internal.pushRoute("/");
            }
        }
    }

    getInvoiceDownloadLinkAndOpen = async (customerOrderId) => {
        let response = await api({
            method: 'get',
            url: `customer-orders/invoice/${customerOrderId}`,
            authorization: this.props.internal.user.access_token
        })

        if (true === response.success) {
            window.open(response.data.data.link, '_blank');
        }
    }

    getServiceProtocolDownloadLinkAndOpen = async (serviceProtocolId) => {
        let response = await api({
            method: 'get',
            url: `service-protocols/export/${serviceProtocolId}`,
            authorization: this.props.internal.user.access_token
        })

        if (true === response.success) {
            window.open(response.data.data.url, '_blank');
        }
    }

    getContractWithdrawalDownloadLinkAndOpen = async (serviceProtocolId) => {
        let response = await api({
            method: 'get',
            url: `contract-withdrawals/export/${serviceProtocolId}`,
            authorization: this.props.internal.user.access_token
        })

        if (true === response.success) {
            window.open(response.data.data.url, '_blank');
        }
    }



    handleChangeModule = (data, rowData) => {
        if (this.props.backToShoppingCart) {
            if (this.props.production) {
                this.props.internal.setBackToShoppingCart(true)
            }
        } else if (this.props.backToOrderDetail) {
            this.props.internal.setBackToOrderDetail(toJS(this.props.internal.route.link))
        }
        this.setState({ anchorEl: null })

        if (data.redirect === 'system') {
            this.props.internal.setLastVisitedPage('/top-products')
            this.props.internal.pushRoute(`products/${rowData.product_id}/edit/tab=0`)
        } else if (data.redirect === 'eshop') {
        } else if (this.props.module) {
            let moduleAndId = this.props.module ? this.props.module : ''
            moduleAndId = moduleAndId + '/' + this.props.id + '/'

            let currentModule = this.props.module.replace('/', '')
            let deleteData = {
                module: currentModule,
                id: this.props.id
            }

            // this.props.internal.pushRoute(url)

            if (data.action === 'delete') {
                //this.setState({openDeleteDialog: true, anchorEl: null})
                this.setState({ anchorEl: null })
                this.props.internal.setActionDelete()

                if (rowData.shop) {
                    if (rowData.product_id) {
                        deleteData.id = rowData.product_id
                    } else {
                        deleteData.id = rowData.id
                    }
                    this.props.internal.setActionDeleteObj(deleteData)
                } else {
                    this.props.internal.setActionDeleteObj(deleteData)
                }
            } else if (data.action === 'download') {
                window.open(this.props.data.url || this.props.data.download, '_blank')
            } else if (data.action === 'edit') {
                this.setState({ anchorEl: null })
                let data = {
                    edit: true,
                    id: this.props.id
                }
                this.props.internal.setActionEdit(data)
            } else if (data.action === 'detail') {
                if (this.props.production) {
                    this.props.internal.pushRoute(moduleAndId + data.action)
                } else {
                    this.props.internal.setSnackbar(
                        this.props.translate.i18n.MODULES.CLIENTS.PRODUCT_UNAVAILABLE,
                        true
                    )
                }
            } else if (data.action === 'detail_order') {
                this.setState({ anchorEl: null })
                let data = {
                    edit: true,
                    id: this.props.id
                }
                this.props.internal.setActionEdit(data)
                this.props.internal.pushRoute(
                    toJS(this.props.internal.route.link) + `/${this.props.id}`
                )
            } else if (data.action === 'edit_weight') {
                this.setState({ anchorEl: null })
                let data = {
                    edit: true,
                    id: this.props.id
                }
                this.props.internal.setActionEdit2(data)
            } else if (
                data.url2 &&
                this.props.id !== Number(toJS(this.props.internal.user.data.id))
            ) {
                this.props.internal.pushRoute(moduleAndId + data.url2)
            } else if (data.action === 'fixed-sets') {
                window.open(`${rowData.shop.url}${rowData.alias}`, '_blank')
            } else if (data.action === 'top-products') {
                window.open(`${rowData.shop.url}${rowData.alias}`, '_blank')
            } else if (
              [1,2,5].indexOf(toJS(this.props.internal.user.data.role.id) > -1) &&
                data.action === 'login-as'
            ) {
                this.loginAsUser(rowData.client_id, rowData.id)
            } else if (data.action === 'invoice') {
                this.getInvoiceDownloadLinkAndOpen(rowData.id);
            } else if (data.action === 'service-protocol') {
                this.getServiceProtocolDownloadLinkAndOpen(rowData.id);
            } else if (data.action === 'contract-withdrawal') {
                this.getContractWithdrawalDownloadLinkAndOpen(rowData.id);
            } else if (data.action === 'sort-category-parameters') {
                data.module.setState({
                    isCategoryParametersSortDialogOpened: true,
                    categoryParameters: rowData.parameters,
                    categoryParametersID: rowData.id
                })
            } else if (data.action === 'issue-card') {
                this.props.internal.pushRoute(`/issue-cards/${rowData.id}/basic`)
            } else if (data.action === 'issue-card-history-export') {
                this.initiateIssueCardHistoryExport(rowData.id)
            } else if (data.action === 'issue-card-export') {
                this.initiateIssueCardExport(rowData.id)
            } else if (data.hasOwnProperty('callback')) {
                data.callback(rowData)
            } else {
                this.props.internal.pushRoute(moduleAndId + data.url)
            }
        } else {
            if (data.action === 'notifications') {
                this.setState({ loading: true })

                // @rs mark the clicked notification as a read one
                this.setReadNotification(toJS(data.notification_id)).then(() => {
                    // always gotta fetch new notifications, to update the local ones...
                    this.getUserData();
                    this.setState({ anchorEl: null })

                    let dataEditDialog = {
                        edit: true,
                        id: this.props.id
                    }

                    this.props.internal.setActionEdit(dataEditDialog)
                    this.props.internal.setNotiifiId(toJS(data.notification_id))

                    this.props.internal.pushRoute('/')
                    this.props.internal.pushRoute(data.url)

                    this.setState({ loading: false })
                })
                // window.location.reload()
                // this.setReadNotification(toJS(data.notification_id))
            } else {
                this.props.internal.pushRoute('/')
                this.props.internal.pushRoute(data.url)
            }
        }
    }

    editArticle = id => {
        this.props.internal.pushRoute(`/${this.props.data.shop_id}/menu/article/${id}`)
    }

    render() {
        // if (this.props.data && ! this.props.data.id) {
        //     return null;
        // }
        return (
            <div className={`custom-btn`}>
                {/* <DeleteDialog open={this.state.openDeleteDialog} close={this.handleCloseDeleteDialog}/> */}
                {this.props.dropdownMenu ? (
                    <CustomMenu
                        anchorEl={this.state.anchorEl}
                        open={this.state.anchorEl}
                        onClose={this.handleClose}
                        className={'cusomMenu' + this.props.notifications ? ' notifications' : ''}
                        ref={ref => (this.custommenu = ref)}
                    >
                        {this.props.data && [4, 5, 8].indexOf(this.props.data.frontend_menu_type_id) !== -1 ? (
                            <MenuItem
                                key={uuid()}
                                onClick={() => this.editArticle(toJS(this.props.data.id))}
                            >
                                {this.props.translate.i18n.MODULES.MENU.EDIT_ARTICLE}
                            </MenuItem>
                        ) : null}
                        {this.props.items.map((data) => {
                            return (
                                <MenuItem
                                    key={uuid()}
                                    onClick={() =>
                                        this.handleChangeModule(data, toJS(this.props.data))
                                    }
                                    disabled={data.disabled}
                                    className={data.readed ? `readed-${data.readed}` : ''}
                                >
                                    {this.props.notifications ? (
                                      <Fragment>
                                          {data.order_status && (
                                            <Tooltip title={this.props.translate.i18n.MODULES.CLIENTS.OREDER_STATE[data.order_status.toUpperCase()]} placement={'right'}>
                                                <ListItemIcon>
                                                    {'approved' === data.order_status && <CheckCircle style={{ color: '#79C552' }} fontSize={'small'}/>}
                                                    {'denied' === data.order_status && <RemoveCircle fontSize={'small'}/>}
                                                    {'new' === data.order_status && <Error style={{ color: '#ee5c4e' }} fontSize={'small'}/>}
                                                </ListItemIcon>
                                            </Tooltip>)}
                                          <ListItemText
                                            primary={data.title}
                                            secondary={`${data.created_at}${data.secondary ? ' - ' + data.secondary : ''}`}
                                            className={'notification-item'}
                                          />
                                      </Fragment>
                                    ) : (
                                        data.title
                                    )}
                                </MenuItem>
                            )
                        })}
                    </CustomMenu>
                ) : null}

                {this.props.showBadge ? (
                    <Badge badgeContent={this.props.numberOfNotifications} className={'badge'}>
                        <IconButton
                            aria-label={this.props.label}
                            onClick={this.handleClick}
                            aria-owns={this.state.anchorEl ? 'menu' : null}
                            aria-haspopup='true'
                        >
                            {/* @rs added loading option */}
                            {this.state.loading ? (
                                <CircularProgress className={'circular-progress mini'} />
                            ) : (
                                this.props.children
                            )}
                        </IconButton>
                    </Badge>
                ) : (
                    <IconButton
                        aria-label={this.props.label}
                        onClick={this.handleClick}
                        aria-owns={this.state.anchorEl ? 'menu' : null}
                        aria-haspopup='true'
                    >
                        {this.props.children}
                    </IconButton>
                )}
            </div>
        )
    }

    initiateIssueCardHistoryExport(id) {
        api({
            method: 'get',
            url: `issue-cards/${id}/export-history`,
            authorization: this.props.internal.user.access_token,
        }).then(response => {
            if (response.success) {
                window.open(response.data.data.url, '_blank')
            }
        })
    }

    initiateIssueCardExport(id) {
        api({
            method: 'get',
            url: `issue-cards/${id}/export`,
            authorization: this.props.internal.user.access_token,
        }).then(response => {
            if (response.success) {
                window.open(response.data.data.url, '_blank')
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/customIconButton/index.js